import PropTypes from 'prop-types';

import * as Styled from './Indicator.styles';

function Indicator({
  progressDuration = 5000,
  isCompleted = true,
  isInProgress = false
}) {
  const showInProgress = !isCompleted && isInProgress;

  return (
    <Styled.Root isCompleted={isCompleted} role="progressbar">
      {showInProgress && (
        <Styled.ProgressAnimation data-testid="progress-animation" progressDuration={progressDuration} />
      )}
    </Styled.Root>
  );
}

Indicator.propTypes = {
  progressDuration: PropTypes.number,
  isCompleted: PropTypes.bool,
  isInProgress: PropTypes.bool
};

export { Indicator };
